import code from './code.js';
import json from './json.js';

export default { js: code, jsx: code, ts: code, json };
